import Vue from 'vue';

export default Vue.filter('boolACadena', function (booleano, cadenaVerdadero, cadenaFalso) {
    return booleano ? cadenaVerdadero : cadenaFalso;
});